import { PageScaffold } from "../../shared/ui/PageScaffold";

const teacherLinks = [
  { to: "/t/:tenantSlug/teacher", label: "講師ホーム" },
  { to: "/t/:tenantSlug/teacher/absence-request/new", label: "欠勤申請" }
];

export function TeacherOccurrenceDetailPage() {
  return (
    <PageScaffold
      title="Teacher Occurrence Detail"
      description="講師向け開催詳細画面のプレースホルダーです。"
      links={teacherLinks}
    >
      <p>ここに担当 occurrence の詳細を表示します。</p>
    </PageScaffold>
  );
}
